import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetSmartbannerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({repository, log}) {
    super({
      repository,
      log
    })

    this._repository = repository
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>} returns smartbanner config
   * @property {Object} smartbanner
   */
  execute = () => Promise.resolve(this._repository.getSmartbanner().toJSON())
}
